var clientConfig = require('./clientConfig.json');

var command = require('./command.json');

var createCommand = require('./createCommand.json');

var createEvent = require('./createEvent.json');

var deleteUser = require('./deleteUser.json');

var emit = require('./emit.json');

var event = require('./event.json');

var eventProcessed = require('./eventProcessed.json');

var noAction = require('./noAction.json');

var request = require('./request.json');

var signIn = require('./signIn.json');

var signOut = require('./signOut.json');

var signUp = require('./signUp.json');

var socketConnected = require('./socketConnected.json');

var socketDisconnected = require('./socketDisconnected.json');

var socketReconnected = require('./socketReconnected.json');

var startEpics = require('./startEpics.json');

var startMicroservice = require('./startMicroservice.json');

var startRouteEpics = require('./startRouteEpics.json');

var stopMicroservice = require('./stopMicroservice.json');

var stopRouteEpics = require('./stopRouteEpics.json');

var updateUser = require('./updateUser.json');

var userTokenRetrieved = require('./userTokenRetrieved.json');

exports.clientConfig = clientConfig;
exports.command = command;
exports.createCommand = createCommand;
exports.createEvent = createEvent;
exports.deleteUser = deleteUser;
exports.emit = emit;
exports.event = event;
exports.eventProcessed = eventProcessed;
exports.noAction = noAction;
exports.request = request;
exports.signIn = signIn;
exports.signOut = signOut;
exports.signUp = signUp;
exports.socketConnected = socketConnected;
exports.socketDisconnected = socketDisconnected;
exports.socketReconnected = socketReconnected;
exports.startEpics = startEpics;
exports.startMicroservice = startMicroservice;
exports.startRouteEpics = startRouteEpics;
exports.stopMicroservice = stopMicroservice;
exports.stopRouteEpics = stopRouteEpics;
exports.updateUser = updateUser;
exports.userTokenRetrieved = userTokenRetrieved;